/* eslint-disable no-console */

import geoConfirm from 'services/utils/confirm';

import { StyledMenuItem } from './style';

import Icon from '@map/components/Icons';
import { useSnackbar } from 'notistack';
import { useRef } from 'react';

  export const DownloadAndServices = ({    
    layer,
    canDownload,
    hasManualLinkDownload,    
    handleClosePopOver
  }) => {

    const serviceLinkWMSRef = useRef();
    const serviceLinkWFSRef = useRef();
    const { enqueueSnackbar } = useSnackbar();

    return (              
      <>
        <div className="title-content">
          <span>Download</span>
          <hr />
        </div>
        {canDownload ? (
          layer.properties?.disabledServices?.string[0] === 'WMS' ? (
            (<div className="item-content"><p>Download indisponível.</p></div>)          
          ) : (
                <div>
                  {!hasManualLinkDownload ? (
                    <StyledMenuItem
                      component={(layer.type === 'criada' || layer.type === 'importada') ? 'li' : 'a'}
                      onClick={() => {
                        (layer.type === 'criada' || layer.type === 'importada') && layer.getKmlFile();
                        handleClosePopOver();
                      }}
                      href={
                        layer.additionalProps !== null &&
                        layer.additionalProps.server === 'Link externo'
                          ? layer.additionalProps.link
                          : layer.getDownloadLink('kml')
                      }
                      target="_self"
                      download
                    >
                      <div className="item-content">
                        <span className="item-label">KML</span>
                        <Icon i="map-download" fill={'#3C71DD'} />
                      </div>
                    </StyledMenuItem>
                  ) : ''}
                  <StyledMenuItem
                    component={(layer.type === 'criada' || layer.type === 'importada') ? 'li' : 'a'}
                    onClick={() => {
                      (layer.dataType === "MultiPolygon" || layer.dataType === "GeometryCollection") && (layer.type === 'criada' || layer.type === 'importada') ? 
                        geoConfirm ({
                          message:
                            'As camadas vetoriais que possuem geometria multipartes serão divididas em feições individuais, mantendo os atributos originais de cada parte.',
                          callback: (confirmed) => {
                            if (confirmed) {
                              layer.getShapefile();
                              handleClosePopOver();
                            }
                          },
                          gap: 16,
                        })
                      :
                        (layer.type === 'criada' || layer.type === 'importada') && layer.getShapefile();
                        handleClosePopOver();
                    }}
                    href={
                      layer.additionalProps !== null &&
                      layer.additionalProps.server === 'Link externo'
                        ? layer.additionalProps.link
                        : layer.getDownloadLink('shapefile')
                    }
                    target="_self"
                    download
                  >
                    <div className="item-content">
                      <span className="item-label">Shapefile</span>
                      <Icon i="map-download" fill={'#3C71DD'} />
                    </div>
                  </StyledMenuItem>   
                </div>
              ) 
        ) : (
          <div className="item-content">
            <p>
              {layer.additionalProps !== null &&
              layer.additionalProps.messageDownload
                ? layer.additionalProps.messageDownload
                : 'Dado não produzido pelo INEMA. Acesse o metadado para mais informações sobre a camada.'}
            </p>
          </div>
        )}
        {layer.additionalProps !== null &&
          layer.additionalProps.showServiceLink &&
          layer.additionalProps.showServiceLink === '1' && (
            <div>
              <div className="title-content">
                <span>Serviços</span>
                <hr />
              </div>
              {layer.canShowInternalEnableService('WMS') && (
                <StyledMenuItem
                  onClick={() => {
                    serviceLinkWMSRef.current.select();
                    serviceLinkWMSRef.current.setSelectionRange(
                      0,
                      99999
                    );
                    document.execCommand('copy');
                    enqueueSnackbar({
                      message: 'Link copiado',
                      variant: 'success',
                    });
                    handleClosePopOver();
                  }}
                  target="_self"
                  download
                >
                  <div className="item-content">
                    <span className="item-label">WMS</span>
                    <textarea ref={serviceLinkWMSRef}>
                      {layer.getFullServiceLink('WMS')}
                    </textarea>
                    <Icon i="map-copy" />
                  </div>
                </StyledMenuItem>
              )}
              {layer.canShowInternalEnableService('WFS') && (
                <StyledMenuItem
                  onClick={() => {
                    serviceLinkWFSRef.current.select();
                    serviceLinkWFSRef.current.setSelectionRange(
                      0,
                      99999
                    );
                    document.execCommand('copy');
                    enqueueSnackbar({
                      message: 'Link copiado',
                      variant: 'success',
                    });
                    handleClosePopOver();
                  }}
                  target="_self"
                  download
                >
                  <div className="item-content">
                    <span className="item-label">WFS</span>
                    <textarea ref={serviceLinkWFSRef}>
                      {layer.getFullServiceLink('WFS')}
                    </textarea>
                    <Icon i="map-copy" />
                  </div>
                </StyledMenuItem>
              )}
              {!layer.canShowInternalEnableService('WMS') &&
                !layer.canShowInternalEnableService('WFS') && (
                  <div className="item-content">
                    <p>Camada não possui serviços disponíveis.</p>
                  </div>
                )}
            </div>
          )}
      </>                       
    )
}